// removed by extract-text-webpack-plugin
module.exports = {"title":"IncompleteCart__title","errormsg":"IncompleteCart__errormsg","greyerrormsg":"IncompleteCart__greyerrormsg","greycolor":"IncompleteCart__greycolor","linkpace":"IncompleteCart__linkpace","mediumlink":"IncompleteCart__mediumlink"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/IncompleteCart/IncompleteCart.scss
// module id = 2330
// module chunks = 8